export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  formValues: {
    marketingAgreed: null,
    milkAllergy: null,
    privacyAgreement: null,
    weightLossReceive: null,
    email: null,
  },
})
